import React from "react";
import axios from "axios";
import "./style.css";
import HeaderEn from "../../header-en";
import FooterEn from "../../footer-en";

import ArashFendereskiImage from "../../../../assets/CEO-Profile.png";
import ParianNaseriniaImage from "../../../../assets/PSY-Profile-Parian.png";
import AzinSalimiImage from "../../../../assets/PSY-Profile-Azin.png";

class AboutEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendMessage: "Hello,I'mInAboutPageEn",
    };
  }

  componentDidMount = () => {
    this.handleRedirect();
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  render() {
    return (
      <div>
        <HeaderEn />
        <div className="about-container d-ltr">
          <div className="d-flex flex-column justify-content-center align-items-center align-text-center">
            <h1>{"We are a team of AI experts and psychologists,"}</h1>
            <h2>
              {
                "Working on tech based solutions for autism diagnosis and rehabilitation"
              }
            </h2>
          </div>
          <div className="about-body">
            <div className="about-card">
              <div className="about-image">
                <img src={ArashFendereskiImage}></img>
                <span className="circle-spin"></span>
              </div>
              <div className="about-content">
                <a href="/en/about/arash-fendereski">Arash Fendereski</a>
                <h3>AI Expert</h3>
                <p>
                  With more than 5 years of experience in AI-based solution, I
                  can solve any computational problem with the help of
                  convolutional neural networks
                </p>
              </div>
            </div>
            <div className="about-card">
              <div className="about-image">
                <img src={ParianNaseriniaImage}></img>
                <span className="circle-spin"></span>
              </div>
              <div className="about-content">
                <a href="/en/about/parian-naserinia">Parian Naserinia</a>
                <h3>Music Therapist</h3>
                <p>
                  Combining Music impacts on brain with child psychology, makes
                  me beleive that children with special needs can make progress
                  during their cognitive skills
                </p>
              </div>
            </div>
            <div className="about-card">
              <div className="about-image">
                <img src={AzinSalimiImage}></img>
                <span className="circle-spin"></span>
              </div>
              <div className="about-content">
                <a href="/en/about/azin-salimi">Azin Salimi</a>
                <h3>Child Psychologists</h3>
                <p>
                  When a child couldn't concentrate on anything or is
                  hyperactive, what we should do? I help people to solve this
                  problem with state-of-the-art rehabilitation protocols
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterEn />
      </div>
    );
  }
}

export default AboutEn;
